export default {
    dev: {
        server: 'https://barrigarest.wcaquino.me'
        // server: 'http://localhost:3001'
        //server: 'http://192.168.0.184:3000'
    }
};



// WEBPACK FOOTER //
// ./src/config/ambienteConfig.js